export default {
    formId: "PassphraseForm",
    formField: {
        password: {
            name: 'password',
            label: 'Contraseña / Frase *',
            requiredErrorMsg: 'Debe especificar la contraseña'
        },
    },
};
